export default function ContactCTA() {
  const openTawkChat = () => {
    if (window.Tawk_API && typeof window.Tawk_API.maximize === 'function') {
      window.Tawk_API.maximize();
    }
  };

  return (
    <section id="contact" className="py-16 md:py-32 px-4 md:px-8 bg-[#0d0d0f]">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-5 gap-8 md:gap-16 items-center">
          <div className="md:col-span-2 text-center md:text-left">
            <div className="flex justify-center md:justify-start">
              <img 
                src="https://static.readdy.ai/image/f6a69fc0db13ffc35ada9ab7bd949426/e71afb08991a347b1acfd62fa5c8c9d4.png" 
                alt="Asher Reviews Logo" 
                className="w-48 h-48 md:w-[300px] md:h-[300px] mb-6 md:mb-8"
              />
            </div>
            <div className="inline-block px-4 md:px-6 py-2 bg-[#39ff14] text-[#0d0d0f] font-bold text-xs md:text-sm uppercase tracking-wider rounded-full mb-4 md:mb-6">
              LET'S WORK TOGETHER
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-4 md:mb-6">Ready to Get Real Feedback?</h2>
            <p className="text-base md:text-xl text-[#b8b8b8] leading-relaxed">
              Chat with me directly and let's talk about your game. I'm here to help make it awesome for kids like me!
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="bg-[#1a1a1d] rounded-2xl md:rounded-3xl p-8 md:p-16 text-center">
              <div className="mb-8 md:mb-12">
                <div className="inline-flex items-center justify-center w-20 h-20 md:w-28 md:h-28 bg-[#00f0ff]/10 rounded-full mb-6 md:mb-8">
                  <i className="ri-message-3-line text-5xl md:text-7xl text-[#00f0ff]"></i>
                </div>
                <h3 className="text-2xl md:text-4xl font-bold text-white mb-4 md:mb-6">
                  Let's Chat About Your Game!
                </h3>
                <p className="text-base md:text-xl text-[#b8b8b8] leading-relaxed max-w-2xl mx-auto mb-8 md:mb-10">
                  Click the button below to start a conversation. Tell me about your game, ask questions, or request a review. I'll respond as soon as I can!
                </p>
              </div>

              <button
                onClick={openTawkChat}
                className="inline-flex items-center justify-center gap-3 px-8 md:px-12 h-14 md:h-16 bg-[#39ff14] text-[#0d0d0f] font-bold text-lg md:text-xl rounded-full hover:shadow-[0_0_30px_rgba(57,255,20,0.8)] transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-chat-smile-3-fill text-2xl"></i>
                <span>Start Chatting Now</span>
              </button>

              <div className="mt-8 md:mt-10 flex flex-wrap items-center justify-center gap-4 md:gap-6 text-sm md:text-base text-[#b8b8b8]">
                <div className="flex items-center gap-2">
                  <i className="ri-time-line text-[#00f0ff]"></i>
                  <span>Quick Response</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-shield-check-line text-[#00f0ff]"></i>
                  <span>Direct Communication</span>
                </div>
                <div className="flex items-center gap-2">
                  <i className="ri-message-2-line text-[#00f0ff]"></i>
                  <span>Easy & Convenient</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// TypeScript declaration for Tawk.to
declare global {
  interface Window {
    Tawk_API?: {
      maximize?: () => void;
      minimize?: () => void;
      toggle?: () => void;
      showWidget?: () => void;
      hideWidget?: () => void;
    };
  }
}
